import { render, staticRenderFns } from "./ShinnyuZu.vue?vue&type=template&id=4785d04b&scoped=true"
import script from "./ShinnyuZu.vue?vue&type=script&lang=js"
export * from "./ShinnyuZu.vue?vue&type=script&lang=js"
import style0 from "./ShinnyuZu.vue?vue&type=style&index=0&id=4785d04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785d04b",
  null
  
)

export default component.exports